import { IconShieldLock, IconUsersGroup, IconWorld } from "@tabler/icons-react";

// Mirrors the backend `PostVisibility` enum; `value` is the API keyword and
// must never be translated.
export const DEFAULT_VISIBILITY = "public";

// Labels are resolved at call time so they follow the active language.
export const getVisibilityOptions = (t) => [
    {
        value: "public",
        Icon: IconWorld,
        label: t("publishPost.visibility.options.public.label"),
        description: t("publishPost.visibility.options.public.description"),
    },
    {
        value: "only_members",
        Icon: IconUsersGroup,
        label: t("publishPost.visibility.options.only_members.label"),
        description: t("publishPost.visibility.options.only_members.description"),
    },
    {
        value: "only_admins",
        Icon: IconShieldLock,
        label: t("publishPost.visibility.options.only_admins.label"),
        description: t("publishPost.visibility.options.only_admins.description"),
    },
];
